import React from 'react';

/* helper – resolves to /public/assets/images/<path> */
const img = (file) => `${process.env.PUBLIC_URL}/assets/images/${file}`;

export default function Contact() {
  return (
    <div className="page">
      {/* ──────────  PAGE-TITLE STRIPE  ────────── */}
      <div className="ttm-page-title-row">
        <div className="ttm-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="page-title-heading ttm-textcolor-white">
                  <h2 className="title">Contact&nbsp;Us</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ──────────  SITE-MAIN  ────────── */}
      <div className="site-main">

        {/* =====  WHO-WE-ARE + INFO STRIPE  ===== */}
        <section className="ttm-row clearfix">
          <div className="container">
            <div className="row align-items-center">
              {/* left image */}
              <div className="col-lg-6">
                <div className="ttm_single_image-wrapper">
                  <img className="img-fluid" src={img('single-img-12.jpg')} alt="contact" />
                </div>
              </div>

              {/* right copy + three icon boxes */}
              <div className="col-lg-6">
                <div className="pl-20 res-991-pl-0 res-991-pt-40">
                  <div className="section-title">
                    <div className="title-header">
                      <h5>Who we are</h5>
                      <h2 className="title">Contact&nbsp;With&nbsp;Us.</h2>
                    </div>
                  </div>
                  <p>Our language experts can assist you if you're seeking translation, localization, voice-over, or content-adaptation services.</p>

                  {[
                    ['ti-location-pin', 'Our Office Locations', 'Sector 50, Noida, Uttar Pradesh 201303'],
                    ['ti-email',        'Drop Mail On',         'info@metamindinc.com'],
                    ['ti-headphone',    'Call Us On',           '9876552511'],
                  ].map(([icon, title, text]) => (
                    <React.Fragment key={icon}>
                      <div className="featured-icon-box icon-align-before-content icon-ver_align-top">
                        <div className="featured-icon">
                          <div className="ttm-icon ttm-icon_element-fill ttm-icon_element-size-sm ttm-icon_element-style-rounded ttm-icon_element-color-grey">
                            <i className={`ti ${icon}`} />
                          </div>
                        </div>
                        <div className="featured-content">
                          <div className="featured-title"><h5>{title}</h5></div>
                          <div className="featured-desc"><p>{text}</p></div>
                        </div>
                      </div>
                      <div className="ttm-horizontal_sep mt-20 mb-20" />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =====  GET-IN-TOUCH CARD  ===== */}
        <section className="ttm-row p-0 res-991-p-0 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="ttm-col-bgcolor-yes ttm-bg ttm-bgcolor-white z-index-2 spacing-13 box-shadow_2">
                  <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"><div className="ttm-col-wrapper-bg-layer-inner" /></div>

                  <div className="layer-content text-center">
                    <div className="mb-30 res-991-mb-0">
                      <h2 className="mb-0">Get In Touch</h2>
                      <p>Need high-quality translation services in Indian languages like Hindi, Tamil, Bengali, Marathi, or more? Fill out the form below and our team will reply promptly.</p>
                    </div>

                    {/* vanilla HTML form – keep markup for CSS */}
                    <form className="contact_form_2 wrap-form clearfix" onSubmit={(e)=>e.preventDefault()}>
                      <div className="row">
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input type="text" name="name" placeholder="Your Name" required />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input type="email" name="email" placeholder="Your Email" required />
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input type="text" name="phone" placeholder="Phone Number" required />
                            </span>
                          </label>
                          <label>
                            <span className="text-input">
                              <textarea rows="3" name="message" placeholder="Message" required />
                            </span>
                          </label>
                        </div>
                      </div>

                      <div className="mt-35">
                        <button type="submit" className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor">
                          Send&nbsp;Message
                        </button>
                      </div>
                    </form>
                  </div>{/* layer-content */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =====  EMBEDDED GOOGLE MAP  ===== */}
        <section>
          <div id="google_map" className="google_map">
            <div className="map_container">
              <div id="map" className="map_1">
                <iframe
                  title="office-map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.9294393740465!2d77.36157827528667!3d28.57188147569782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce593a620c4b5%3A0xf7cbc75d7c67a7ed!2sB%20Block%20Rd%2C%20Sector%2050%2C%20Noida%2C%20Uttar%20Pradesh%20201303!5e0!3m2!1sen!2sin!4v1744995003365!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </section>

      </div>{/* site-main */}
    </div>
  );
}